import React, { useEffect, useState, useCallback } from "react";
import { getAnnouncements } from "@/lib/api";
import { useLiveStream } from "@/lib/useLiveStream";
import "@/App.css";

const SEV_META = {
  emergency: { label: "Emergency", icon: "fa-tower-broadcast" },
  warning: { label: "Warning", icon: "fa-bell" },
  advisory: { label: "Advisory", icon: "fa-triangle-exclamation" },
  info: { label: "Notice", icon: "fa-circle-info" },
};

const PublicStatusPage = () => {
  const [items, setItems] = useState([]);
  const [flash, setFlash] = useState(false);

  const load = useCallback(() => {
    getAnnouncements().then((d) => setItems(d.items || [])).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  // Instant: the public channel pushes announcements the moment they're issued
  useLiveStream("public", (evt) => {
    if (evt.type === "announcement") {
      load();
      if (evt.payload?.action === "new") {
        setFlash(true);
        setTimeout(() => setFlash(false), 1200);
      }
    }
  });

  const emergency = items.find((a) => a.severity === "emergency");
  const rest = items.filter((a) => a.severity !== "emergency");

  return (
    <div className="pub-status" data-testid="public-status-page">
      <header className="pub-head">
        <div className="pub-brand">
          <div className="pub-mark"><i className="fa-solid fa-shield-halved" /></div>
          <div>
            <h1>Barbados Public Alerts</h1>
            <p>Official advisories from the National Traffic Command Centre</p>
          </div>
        </div>
        <div className={`pub-live ${flash ? "flash" : ""}`} data-testid="public-live-indicator">
          <span className="live-dot" /> Live
        </div>
      </header>

      {emergency && (
        <div className="pub-emergency" data-testid="public-emergency-banner">
          <div className="pub-emergency-tag"><i className="fa-solid fa-tower-broadcast" /> Emergency Alert</div>
          <h2>{emergency.title}</h2>
          <p>{emergency.body}</p>
          <div className="pub-emergency-meta">
            <i className="fa-solid fa-location-dot" /> {emergency.target} · {emergency.category}
          </div>
        </div>
      )}

      <main className="pub-body">
        {items.length === 0 && (
          <div className="pub-allclear" data-testid="public-all-clear">
            <i className="fa-solid fa-circle-check" />
            <h2>All Clear</h2>
            <p>There are no active public advisories at this time.</p>
          </div>
        )}

        {rest.map((a) => {
          const m = SEV_META[a.severity] || SEV_META.info;
          return (
            <article key={a.id} className={`pub-card ${a.severity}`} data-testid={`public-announcement-${a.id}`}>
              <div className="pub-card-top">
                <span className={`pub-sev ${a.severity}`}><i className={`fa-solid ${m.icon}`} /> {m.label}</span>
                <span className="pub-card-time">{typeof a.minutes_ago === "number" ? `${a.minutes_ago}m ago` : ""}</span>
              </div>
              <h3>{a.title}</h3>
              <p>{a.body}</p>
              <div className="pub-card-meta"><i className="fa-solid fa-location-dot" /> {a.target} · {a.category}</div>
            </article>
          );
        })}
      </main>

      <footer className="pub-foot">
        Issued by the Government of Barbados · National Traffic Command Centre
      </footer>
    </div>
  );
};

export default PublicStatusPage;
